<script setup>
import { ref, onMounted, watch } from 'vue'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        required: false
    },
    placeholder: {
        type: String,
    },
    textareaClass: {
        type: String,
    },
    textareaStyle: {
        type: String,
    },
    autoHeight: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

const textarea = ref(null)

const autoResize = () => {
    if (!props.autoHeight) return

    const el = textarea.value
    // console.log(el)
    // el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
}

onMounted(() => {
    autoResize()
})

const onInput = (event) => {
    emit('update:modelValue', event.target.value)
    autoResize()
}

watch(() => props.modelValue, () => {
    autoResize()
})

</script>

<style>

</style>

<template>
    <div class="relative">
        <textarea class="w-full !min-h-[68px] outline-none text-[#101828] placeholder:text-[#667085] text-base font-normal leading-[22px] px-3.5 py-3 border shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] rounded-lg border-[#D0D5DD] focus:shadow-[0px_0px_0px_4px_#F4EBFF,0px_1px_2px_0px_rgba(16,24,40,0.05)] focus:border-[#D6BBFB]" :class="textareaClass" :placeholder="props.placeholder" :value="props.modelValue" @input="onInput($event)" ref="textarea" :style="textareaStyle"></textarea>
    </div>
</template>
